export default __webpack_public_path__ + "static/media/commingsoon.7c38105a.png";